import React, { useState, useEffect, useLayoutEffect } from "react";
import Modal from "components/UI/Modal/Modal";
import { InsertModal, UpdateModal, DeleteModal } from "./Actions";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { routeInfo, userCredentials } from "recoilState/GlobalState";
import { HeaderButton } from "components";
import Add from "@mui/icons-material/Add";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Buttons } from "components";
import { ACTIONS } from "consts/Actions";
import { nivelesTitles as titles } from "consts/titulos-de-tablas";
import styles from "styles/pages/Pages.module.scss";
import { useService, puedeEditarServicio } from "components/route/ServiceRoute";
import XGrid from "components/UI/Grid/XGrid";
import { RNHNivelGet } from "services/services-mia/programa-salud/estructuras/RNHNivelGet";

export default function Niveles() {
    const credentials = useRecoilValue(userCredentials);
    const setRoute = useSetRecoilState(routeInfo);
    const [modalDetails, setModalDetails] = useState({ isOpen: false });
    const [loading, setLoading] = useState(false);
    const [niveles, setNiveles] = useState([]);
    const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
    const { service } = useService();

    const getNiveles = async () => {
        setNiveles([]);
        setRowSelected({ status: false, row: {} });
        setLoading(true);
        const { data: result } = await RNHNivelGet(credentials);
        const newRows = result[0]?.rnhNivelId ? result?.map((data) => {
            return {
                id: data.rnhNivelId,
                cod: data.rnhNivelCod,
                name: data.rnhNivelNombre,
                componenteMaximo: data.rnhNivelComponenteMaximoNombre,
              // No son columnas: viajan en la fila para que Modificar y Eliminar no
              // tengan que volver a pedir el registro.
              version: data.rnhNivelVersion,
              // El COD para el select; `componenteMaximo` es el nombre que ve la grilla.
              maxLevelCod: data.rnhNivelComponenteMaximoCod ?? "",
            };
        }) : []
        setNiveles(newRows);
        setLoading(false);
    }
    const closeModal = () => {
        setModalDetails({ isOpen: false });
    };
    const handleClick = ({ procede, title }) => {
        setModalDetails({ procede, title, isOpen: true });
    };

    useEffect(() => {
        getNiveles()

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useLayoutEffect(() => {
        setRoute({
            wordKey: `Niveles - Programa Salud RN`
        })
    }, [service.servicioNombre, setRoute])

    return (
        <main className={styles.main}>
            <Modal size={modalDetails.procede === ACTIONS.DELETE ? 'sm' : 'md'} open={modalDetails.isOpen} title={modalDetails.title} onClose={closeModal}>
                {modalDetails.procede === ACTIONS.UPDATE && (
                    <UpdateModal
                        row={rowSelected.row}
                        updateList={getNiveles}
                        closeModal={closeModal}
                    />
                )}
                {modalDetails.procede === ACTIONS.DELETE && (
                    <DeleteModal
                        row={rowSelected.row}
                        servicio={service}
                        updateList={getNiveles}
                        closeModal={closeModal}
                        setterRowSelected={setRowSelected}
                    />
                )}
                {modalDetails.procede === ACTIONS.INSERT && (
                    <InsertModal
                        servicio={service}
                        updateList={getNiveles}
                        closeModal={closeModal}
                    />
                )}
            </Modal>
            <div className={styles["filters-actions-right"]}>
                <Buttons>
                    <HeaderButton
                        text={"Actualizar"}
                        onClick={() => { getNiveles() }}
                        disabled={rowSelected.row.id || false}
                    >
                        <Cached />
                    </HeaderButton>
                    <HeaderButton
                        text={"Nuevo Nivel"}
                        handleClick={handleClick}
                        data={{
                            title: "Nuevo Nivel",
                            procede: ACTIONS.INSERT
                        }}
                        disabled={rowSelected.row.id || service.servicioPermiso !== 'E'}
                    >
                        <Add />
                    </HeaderButton>
                    <HeaderButton
                        text={"Modificar Nivel"}
                        handleClick={handleClick}
                        data={{
                            title: "Modificar Nivel",
                            procede: ACTIONS.UPDATE
                        }}
                        disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
                    >
                        <EditOutlined />
                    </HeaderButton>
                    <HeaderButton
                        text={"Eliminar Nivel"}
                        handleClick={handleClick}
                        data={{
                            title: "Eliminar Nivel",
                            procede: ACTIONS.DELETE
                        }}
                        disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
                    >
                        <DeleteOutlineRoundedIcon />
                    </HeaderButton>
                </Buttons>
            </div>
            <div className={styles.container}>
                <XGrid
                    rows={niveles}
                    titles={titles}
                    loading={loading}
                    secondarySelected={rowSelected}
                    setSecondarySelected={setRowSelected}
                />
            </div>
        </main>
    );
}